import { IPromise } from 'angular';

import { IListFetcher } from '../fetchers/IListFetcher';
import { RequestHelper } from '../helpers/RequestHelper';
import { ResultHelper } from '../helpers/ResultHelper';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { Module } from '../Module';
import { GetFieldValuesRequest } from '../ServerApi/requests/GetFieldValuesRequest';
import { GetMetricDataPointsByIdsRequest } from '../ServerApi/requests/GetMetricDataPointsByIdsRequest';
import { IFieldValue } from '../ServerApi/types/IFieldValue';
import { IMetricDataList } from '../ServerApi/types/IMetricDataList';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { FetcherFactory } from '../services/FetcherFactory';
import { ServerService } from '../services/ServerService';
import { ResourceQuery } from './ResourceQuery';

export class MetricDataPoints{

  public static $inject = [
    '$q',
    '$cookies',
    'ErrorNotifyingServer',
    'FetcherFactory',
    'ServerService'
  ];

  constructor(
    private $q: ng.IQService,
    private $cookies: ng.cookies.ICookiesService,
    private ErrorNotifyingServer: ErrorNotifyingServer,
    FetcherFactory: FetcherFactory,
    private server: ServerService,
  // private detailFetcher: IDetailFetcher<IWorkbookDetailInfo>; 
  // we don't have metric detail yet - TFS927416
    private fieldValuesFetcher: IListFetcher<IFieldValue>,
  ) {
    this.server = ErrorNotifyingServer.getServerService();
    // we don't have metric detail yet - TFS927416
    this.fieldValuesFetcher = FetcherFactory.getServerResourceFetcher(GetFieldValuesRequest, ServerApiMapper.fieldValues);

  }

  public getMetricDataPoints(metricIds: string[]): ng.IPromise<IMetricDataList> {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(metricIds, (metricIds) => new GetMetricDataPointsByIdsRequest({metricIds})),
      (results: IMetricDataList[]) => {
        return {
          failures: results.reduce((r, c) => Object.assign(r, c.failures), {}),
          data: results.reduce((r, c) => Object.assign(r, c.data), {}),
        };
      }
    );
  }
}

Module.instance().service('MetricDataPoints', MetricDataPoints);

